document.addEventListener("DOMContentLoaded", function () {
    const productImages = document.querySelectorAll(".media-gallery__item img");

    const hasMouse = window.matchMedia(
        "(hover: hover) and (pointer: fine)"
    ).matches;

    let activeMobileImage = null;

    function resetZoom(img) {
        img.style.transform = "scale(1)";
        img.style.transformOrigin = "center center";
        img.dataset.zoomed = "false";

        if (img.parentElement) {
            img.parentElement.style.cursor = hasMouse ? "zoom-in" : "zoom-in";
        }
    }

    function zoomImage(img, container, clientX, clientY) {
        const rect = container.getBoundingClientRect();

        const x = ((clientX - rect.left) / rect.width) * 100;
        const y = ((clientY - rect.top) / rect.height) * 100;

        const safeX = Math.max(0, Math.min(100, x));
        const safeY = Math.max(0, Math.min(100, y));

        img.style.transformOrigin = `${safeX}% ${safeY}%`;
        img.style.transform = "scale(2)";
        img.dataset.zoomed = "true";

        container.style.cursor = "zoom-out";
    }

    productImages.forEach((img) => {
        const container = img.parentElement;

        if (!container) return;

        container.style.overflow = "hidden";

        img.style.transition = "transform 0.15s ease";
        img.style.transformOrigin = "center center";
        img.dataset.zoomed = "false";

        /*
         * DESKTOP
         * Hover zoom
         */
        if (hasMouse) {
            container.style.cursor = "zoom-in";

            container.addEventListener("mousemove", function (event) {
                zoomImage(
                    img,
                    container,
                    event.clientX,
                    event.clientY
                );
            });

            container.addEventListener("mouseleave", function () {
                resetZoom(img);
            });

            return;
        }

        /*
         * MOBILE / TABLET
         * Tap to zoom
         */

        container.style.cursor = "zoom-in";

        let touchStartX = 0;
        let touchStartY = 0;
        let touchMoved = false;

        container.addEventListener(
            "touchstart",
            function (event) {
                if (!event.touches.length) return;

                touchStartX = event.touches[0].clientX;
                touchStartY = event.touches[0].clientY;
                touchMoved = false;
            },
            { passive: true }
        );

        container.addEventListener(
            "touchmove",
            function (event) {
                if (!event.touches.length) return;

                const deltaX =
                    Math.abs(event.touches[0].clientX - touchStartX);

                const deltaY =
                    Math.abs(event.touches[0].clientY - touchStartY);

                /*
                 * Prevent a gallery swipe / page scroll
                 * being interpreted as a zoom tap.
                 */
                if (deltaX > 10 || deltaY > 10) {
                    touchMoved = true;
                }
            },
            { passive: true }
        );

        container.addEventListener("touchend", function (event) {
            if (touchMoved) return;

            /*
             * Prevent following the image/link if the
             * image happens to be wrapped in an <a>.
             */
            event.preventDefault();

            const touch = event.changedTouches[0];

            if (!touch) return;

            const isZoomed = img.dataset.zoomed === "true";

            /*
             * Second tap = zoom out
             */
            if (isZoomed) {
                resetZoom(img);
                activeMobileImage = null;
                return;
            }

            /*
             * Reset another image that may still be zoomed
             */
            if (
                activeMobileImage &&
                activeMobileImage !== img
            ) {
                resetZoom(activeMobileImage);
            }

            zoomImage(
                img,
                container,
                touch.clientX,
                touch.clientY
            );

            activeMobileImage = img;
        });
    });
});